import React from "react"

import { useImage } from "../../../../hooks/useImage"

export const withImages = Component => ({ name = "Images", images: rawImages }) => {
  const { getFluidImage } = useImage()

  const images = rawImages?.map((image: any) => getFluidImage(image, { maxWidth: 1000 }))

  Component.displayName = name
  return <Component images={images} />
}
